import { Box, Grid, Skeleton } from '@mui/material';
import SimpleVideoThumbnail from '../common/SimpleVideoThumbnail';
import { ChildVideo, VideoManagerItem } from '../types/videos';
import ClearIcon from '@mui/icons-material/Clear';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';

const AnimateThumbnailSkeleton = ({ format }) => {

  return <Box sx={{ position: 'relative' }}>
    <Skeleton variant="rounded" sx={{
      width: format === 'horizontal' ? 250 : 90,
      height: format === 'horizontal' ? 140 : 160,
    }}/>
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }}>
      <PlayArrowIcon fontSize={'large'} sx={{ color: 'grey.300' }}/>
    </Box>
  </Box>;
};

export const VideoItemSkeleton = ({ video }: { video: VideoManagerItem | ChildVideo }) => {
  return <Grid container sx={{ mb: 2 }}>
      <Grid item xs={3}>
        <Grid container spacing={1}>
          <Grid item>
            { video.status !== 'errored' && video.thumbnail && <SimpleVideoThumbnail format={video.format} imageUrl={video.thumbnail} />}
            { video.status !== 'errored' && !video.thumbnail && <AnimateThumbnailSkeleton format={video.format} />}
            { video.status === 'errored' && !video.thumbnail && <Box width={250} height={140} sx={{
              bgcolor: 'red',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '5%'
            }}>
              <ClearIcon />
            </Box>}
          </Grid>
          <Grid item>
            <Skeleton variant="circular" width={40} height={40} />
          </Grid>
        </Grid>
        <Skeleton variant="text" sx={{ fontSize: '1rem' }} />
        <Skeleton variant="text" sx={{ fontSize: '0.8rem' }} />
        <Skeleton variant="text" sx={{ fontSize: '0.8rem' }} />
      </Grid>
    </Grid>;
};